module.exports = __webpack_public_path__ + "static/fonts/Quicksand-Medium.621a1cd.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Quicksand-Medium.woff
// module id = USaj
// module chunks = 1